import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import { URL_PATHS } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
} from "reactstrap"
import {
  getFeatureClicks,
  getFeatureViewsByUser,
  getListFeature,
  resetFeatureClicks,
  resetFeatureViewsByUser,
  resetListFeature,
} from "store/actions"

const ListReport = ({
  history,
  match,
  getFeatureClicks,
  resetFeatureClicks,
  featureClicks,
  listFeature,
  getListFeature,
  resetListFeature,
}) => {
  const { event_id, feature_id } = match?.params
  useEffect(() => {
    getFeatureClicks({
      event_id: event_id,
      feature: "list",
      feature_id: feature_id,
    })
    getListFeature(feature_id)

    return () => {
      resetFeatureClicks()
      resetListFeature()
    }
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="List" />
          <BreadcrumbTitle
            title={listFeature?.name}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, { id: event_id }),
              },
              { title: "List" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {/* <Row>
            <Col xl={4}>
              <Card
                className="shadow-sm"
                style={{
                  height: "115px",
                  border: "1px solid Gainsboro",
                }}
              >
                <Row
                  className="d-flex align-items-center text-center"
                  style={{ height: "100%" }}
                >
                  <Col xs="5">
                    <h6>Total Views</h6>
                    <i className="mdi mdi-eye font-size-18" />
                  </Col>
                  <Col>
                    {!!featureClicks?.total_views
                      ? featureClicks?.total_views
                      : "-"}
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xl={4}>
              <Card
                className="shadow-sm"
                style={{
                  height: "115px",
                  border: "1px solid Gainsboro",
                }}
              >
                <Row
                  className="d-flex align-items-center text-center"
                  style={{ height: "100%" }}
                >
                  <Col xs="5">
                    <h6>Percentage of Views</h6>
                    <i className="mdi mdi-percent-outline font-size-18" />
                  </Col>
                  <Col>
                    {!!featureClicks?.users_percentage
                      ? featureClicks?.users_percentage + "%"
                      : "-"}
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xl={4}>
              <Card
                className="shadow-sm"
                style={{
                  height: "115px",
                  border: "1px solid Gainsboro",
                }}
              >
                <Row
                  className="d-flex align-items-center text-center"
                  style={{ height: "100%" }}
                >
                  <Col xs="5">
                    <h6>Top User</h6>
                    <i className="mdi mdi-star font-size-18" />
                  </Col>
                  <Col>
                    {!!featureClicks?.top_user
                      ? featureClicks?.top_user?.display_name
                      : "-"}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row> */}
          <Card>
            <CardBody>
              <span>
                <b className="font-size-16">List Items</b> (if the list item has
                links, you will be able to see separate reports):
              </span>
              <Row>
                <Col>
                  <ListGroup>
                    {listFeature?.list_items?.map(item => (
                      <ListGroupItem className="mt-3 shadow-sm" key={item?.id}>
                        <Row>
                          <Col className="d-flex flex-column justify-content-center">
                            <h6 className="mb-1">{item?.title_line_1}</h6>
                            <h6 className="mb-1">{item?.title_line_2}</h6>
                            <h6>{item?.title_line_3}</h6>
                          </Col>
                          {item?.links && item?.links?.length > 0 && (
                            <Col
                              xs="auto"
                              className="d-flex flex-column justify-content-center"
                            >
                              <SaveButton
                                type="button"
                                content="View Reports"
                                onClick={() => {
                                  history.push({
                                    pathname: generatePath(
                                      URL_PATHS.LIST_ITEM_REPORTS,
                                      {
                                        event_id: event_id,
                                        feature_id: item?.id,
                                      }
                                    ),
                                    state: {
                                      item: item,
                                      eventId: event_id,
                                      featureId: event_id,
                                    },
                                  })
                                }}
                              />
                            </Col>
                          )}
                        </Row>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  featureClicks: state.Analytics.featureClicks,
  featureViewsByUser: state.Analytics.featureViewsByUser,
  listFeature: state.List.listFeature,
})

const mapDispatchToProps = dispatch => ({
  getFeatureClicks: values => dispatch(getFeatureClicks(values)),
  resetFeatureClicks: () => dispatch(resetFeatureClicks()),
  getFeatureViewsByUser: values => dispatch(getFeatureViewsByUser(values)),
  resetFeatureViewsByUser: () => dispatch(resetFeatureViewsByUser()),
  getListFeature: values => dispatch(getListFeature(values)),
  resetListFeature: () => dispatch(resetListFeature()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ListReport))
